import gql from 'graphql-tag';

import { SESSION_USER_FIELDS } from 'app/shared/graphql/sessions/queries';

export const UPDATE_TICKET = gql`
  mutation updateTicket(
    $email: String!
    $eventAttendeeId: Int!
    $firstName: String
    $lastName: String
  ) {
    updateTicket(
      email: $email
      eventAttendeeId: $eventAttendeeId
      firstName: $firstName
      lastName: $lastName
    ) {
      ticket {
        id
        email
        event {
          id
        }
        eventAttendee {
          id
        }
        firstName
        lastName
        person {
          blocked
          user {
            ...SessionUserFields
          }
        }
        primary
      }
    }
  }
  ${SESSION_USER_FIELDS}
`;
